import { render, staticRenderFns } from "./company.vue?vue&type=template&id=65b979c0&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b979c0",
  null
  
)

export default component.exports